<template>
  <!-- Modal -->
  <div v-if="this.$store.state.modal.exportarExtra.show === true" class="in show modal fade exportarExtra" role="dialog">
    <div class="modal-dialog" role="document">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" v-on:click="fecharModal()">&times;</button>
          <h4 class="modal-title">Exportar Extra Contratual</h4>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-center align-items-center">
            <div class="text-center">
              <label class="form-label" for="ano">Selecione o ano que deseja baixar:</label>
              <input type="number" class="form-control" id="ano" v-model="anoSelecionado" required :min="minYear" :max="maxYear">
            </div>
            <div class="text-center">
              <p v-if="alert" style="color:red;"><b>Selecione o ano!</b></p>
              <button id="button" class="btn-primary" @click="selecionar()">Selecionar</button>
            </div>
          </div>
        </div>
        <!-- modal-footer -->
        <!-- <div class="modal-footer">
        </div>./moda-footer -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      anoSelecionado: new Date().getFullYear(), // Default para o ano atual
      alert: false,
      minYear: 2020, // Definir um ano mínimo razoável
      maxYear: new Date().getFullYear() // Definir o ano máximo como o ano atual
    }
  },
  computed: {
    modalIsVisible() {
      console.log('Estado modal completo no modal:', this.$store.state.modal);
      console.log('Estado modalExportarExtra no modal:', this.$store.state.modalExportarExtra);
      return this.$store.state.modalExportarExtra && this.$store.state.modalExportarExtra.show;
    }
  },
  methods: {
    fecharModal: function () {
      this.alert = false
      // Assumindo que haverá um novo estado para este modal no Vuex store
      this.$store.commit('setModalExportarExtra', { show: false })
    },
    selecionar() {
      if (!this.anoSelecionado) {
        this.alert = true
        return
      }
      this.alert = false
      this.$emit('selecionado', this.anoSelecionado)
      this.fecharModal()
    }
  },
  watch: {
    modalIsVisible(newValue) {
      console.log('Visibilidade do modal mudou para:', newValue);
    }
  }
}
</script>

<style scoped>
.exportarExtra {
  transition: 1s;
  overflow: auto;
}

.modal-dialog {
  width: 25%;
}

.modal {
  z-index: 99990;
}

.modal-header {
  background-color: #3b8dbc;
  text-align: center;
  color: #FFFF;
}

.modal-body {
  position: relative;
  margin-bottom: 1.94em;
}

.modal-footer {
  padding: 14px 37px;
  text-align: right;
  border-top: 1px solid #e5e5e5;
}

label {
  margin-top: 5px;
}

.btn-fechar {
  margin-right: 0.5em;
}

#button {
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// ExportarExtra.vue?8314bcde